import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  console.log('PrivateRoute - isAuthenticated:', isAuthenticated);
  console.log('PrivateRoute - children:', children);
  
  if (!isAuthenticated) {
    console.log('PrivateRoute - redirecting to signin');
    return <Navigate to="/account/signin" />;
  }
  
  console.log('PrivateRoute - rendering protected content');
  return children;
};

export default PrivateRoute; 